import * as notificationsActions from 'client/common/store/actions/notifications';

import NotificationManager from 'client/common/components/notifications/manager';

import {takeEvery} from 'redux-saga/effects';

function commonNotifications(action: any) {
    const {message, timeOut, type} = action.payload;

    NotificationManager.add({
        ...(type && {type}),
        ...(timeOut && {timeOut}),
        ...(message && {message})
    });
}

export default function* router() {
    yield takeEvery(notificationsActions.SHOW_NOTIFICATION, commonNotifications);
}
